// The Match Engine 2.5 captain block from GET /team/strategy. It is absent
// before the ME 2.5 deploy and null when the server could not compute it;
// either way the captain UI stays hidden. Copy here describes states only,
// never engine values.

export const captainId = (captain) => captain?.player?._id || null;

export const isCaptain = (captain, playerId) =>
  Boolean(playerId) && captainId(captain) !== null && String(captainId(captain)) === String(playerId);

// Any outfield player at the club. The server's keeper test is
// fav_position === 'GK'; academy and loaned-out players are refused too.
export const canBeCaptain = (player, academyIds = []) =>
  Boolean(player?._id) &&
  player.fav_position !== 'GK' &&
  !player.loanedOut &&
  player.academy?.status !== 1 &&
  !academyIds.includes(player._id);

export const CAPTAIN_AUTO_COPY = 'Chosen for you each match. Pick your own captain any time, free.';

const BACKING_COPY = {
  high: 'Captain active, strong backing',
  mid: 'Captain active, solid backing',
  low: 'Captain active, little backing',
};

export const captainPreviewCopy = (preview) => {
  switch (preview?.status) {
    case 'active':
      return BACKING_COPY[preview.backing] || 'Captain active';
    case 'benched':
      return 'Captain benched: the side misses his leadership';
    case 'none':
      return 'No captain';
    case 'excused':
      return 'Captain unavailable (injured or suspended)';
    case 'vacated':
      return 'Your captain has left: pick a new one, free';
    default:
      return null;
  }
};

const CHANGE_COPY = {
  first_pick: 'Your first pick is free.',
  vacated: 'Your captain has left: the next pick is free.',
  long_injury: 'Your captain is out injured long-term: the next pick is free.',
  new_manager: 'New manager: the next pick is free.',
  off_season: 'Off-season: changes are free.',
  season_change: 'Changing now uses your one change this season.',
  match_running: 'You can’t change captain during a match.',
  no_changes_left: 'You’ve used this season’s captain change.',
};

export const captainChangeCopy = (change) => {
  if (!change) return null;
  if (CHANGE_COPY[change.reason]) return CHANGE_COPY[change.reason];
  if (!change.allowed) return 'You can’t change captain right now.';
  return change.free ? 'This change is free.' : CHANGE_COPY.season_change;
};

// POST /team/captain refusals. The 403 for a player who isn't at the club has
// an empty body, so a missing reason means that case.
export const captainErrorCopy = (status, reason) => {
  if (status === 403) {
    if (reason === 'academy') return 'Academy players can’t be captain.';
    if (reason === 'keeper') return 'Keepers can’t be captain.';
    return 'That player isn’t at your club.';
  }
  if (status === 409 && (reason === 'match_running' || reason === 'no_changes_left')) {
    return CHANGE_COPY[reason];
  }
  return 'Red card. We’re having issues with our club platform';
};
